import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setLedgerData,
  setLoading,
  setSearchResults,
  setLoadingSearch,
} from "./customerLedgerSlice";
import { getdebitorLedgerApi } from "../../../apiservice/reports";
import { getAccountBySeachApi } from "../../../apiservice/setting";

export const fetchCustomerLedger = createAsyncThunk(
  "customerLedger/fetchCustomerLedger",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(setLoading(true));

      const response = await getdebitorLedgerApi({
        customerId: payload.customerId,
        ledgerType: payload.ledgerType,
        dateFrom: payload.fromDate,
        dateTo: payload.toDate,
      });

      if (response.data) {
        dispatch(setLedgerData(response.data));

        const customerResponse = await getAccountBySeachApi({
          query: "",
          type: "debitor",
          acc_id: payload.customerId,
        });

        if (customerResponse.data && customerResponse.data.length > 0) {
          dispatch(
            setLedgerData({
              ...response.data,
              customer: customerResponse.data[0],
            })
          );
        }
      }

      return response.data;
    } catch (error) {
      console.error("Error fetching customer ledger:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const searchCustomers = createAsyncThunk(
  "customerLedger/searchCustomers",
  async (searchTerm, { dispatch, getState }) => {
    try {
      dispatch(setLoadingSearch(true));

      const state = getState();
      const { auth: authInfo } = state;
   let accountTypes = ["Customer"];

      if (
        authInfo.subscription === "SuperERP" ||
        authInfo.branch_company_type === "Pharmacy"
      ) {
        accountTypes = ["Customer", "Patient"];
      }
  
      const response = await getAccountBySeachApi({
        query: searchTerm.trim(),
        type: "debitor",
        acc_type_name: accountTypes,
      });

      dispatch(setSearchResults(response.data || []));
      return response.data;
    } catch (error) {
      console.error("Error searching customers:", error);
      throw error;
    } finally {
      dispatch(setLoadingSearch(false));
    }
  }
);
